import { getTempAnswers } from 'app/core/http';
import { Exception } from 'app/core/status';

export async function initialTempAnswer(surveyHash: string, tempAnswerHash: string) {
  try {
    const { ansobj } = await getTempAnswers(surveyHash, tempAnswerHash);
    const { tempAnswers } = ansobj;
    return tempAnswers;
  } catch (error) {
    throw new Exception('INVALID_TEMPORARY_SURVEY');
  }
}
